import axios from "axios";
import { app } from "../signals/AppSignal";

import React, { useEffect, useState } from "react";
import { useSignal } from "@preact/signals-react";

interface IAnalytics {
  totalAccount: number;
  totalUser: number;
  totalSubscriber: number;
  totalInstall: number;
}

interface ISales {
  totalFreePlan: number;
  totalBasicPlan: number;
  totalProPlan: number;
  totalUltimatePlan: number;
  totalTrialPlan: number;
  totalEssentialPlan: number;
}

const Dashboard = () => {
  useSignal(0);

  const [analytics, setAnalytics] = useState<IAnalytics | undefined>(undefined);
  const [eamAnalytics, setEamAnalytics] = useState<IAnalytics | undefined>(
    undefined
  );
  const [qritAnalytics, setQritAnalytics] = useState<IAnalytics | undefined>(
    undefined
  );
  const [stdAnalytics, setStdAnalytics] = useState<IAnalytics | undefined>(
    undefined
  );
  const [swnAnalytics, setSwnAnalytics] = useState<IAnalytics | undefined>(
    undefined
  );
  const [stpAnalytics, setStpAnalytics] = useState<IAnalytics | undefined>(
    undefined
  );

  const [totalInstall, setTotalInstall] = useState<number>(0);
  const [totalAccounts, setTotalAccounts] = useState<number>(0);
  const [totalUsers, setTotalUsers] = useState<number>(0);
  const [totalSubscriber, setTotalSubsriber] = useState<number>(0);

  const [sales, setSales] = useState<ISales | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  const getAnalytics = () => {
    axios
      .get(`/api/v1/summary/${app}/analytics`)
      .then((response) => {
        console.log(response.data);
        const result: IAnalytics = response.data;
        setAnalytics(result);
      })
      .catch((error) => {
        setAnalytics(undefined);
      });
  };

  const getEAMAnalytics = () => {
    setEamAnalytics(undefined);
    axios
      .get(`/api/v1/summary/eam/analytics`)
      .then((response) => {
        console.log(response.data);
        const result: IAnalytics = response.data;
        setEamAnalytics(result);
      })
      .catch((error) => {
        setEamAnalytics(undefined);
      });
  };

  const getQRITAnalytics = () => {
    setQritAnalytics(undefined);
    axios
      .get(`/api/v1/summary/qrit/analytics`)
      .then((response) => {
        console.log(response.data);
        const result: IAnalytics = response.data;
        setQritAnalytics(result);
      })
      .catch((error) => {
        setQritAnalytics(undefined);
      });
  };

  const getSTDAnalytics = () => {
    setStdAnalytics(undefined);
    axios
      .get(`/api/v1/summary/smarttd/analytics`)
      .then((response) => {
        console.log(response.data);
        const result: IAnalytics = response.data;
        setStdAnalytics(result);
      })
      .catch((error) => {
        setStdAnalytics(undefined);
      });
  };

  const getSTPAnalytics = () => {
    setStdAnalytics(undefined);
    axios
      .get(`/api/v1/summary/stp/analytics`)
      .then((response) => {
        console.log(response.data);
        const result: IAnalytics = response.data;
        setStpAnalytics(result);
      })
      .catch((error) => {
        setStpAnalytics(undefined);
      });
  };

  const getSWNAnalytics = () => {
    setSwnAnalytics(undefined);
    axios
      .get(`/api/v1/summary/smartwn/analytics`)
      .then((response) => {
        console.log(response.data);
        const result: IAnalytics = response.data;
        setSwnAnalytics(result);
      })
      .catch((error) => {
        setSwnAnalytics(undefined);
      });
  };


  const fetchData = async () => {
    setLoading(true);
    //await getAnalytics();
    //await getSales();
    //await getEAMAnalytics();
    await getQRITAnalytics();
    //await getSTDAnalytics();
    //await getSWNAnalytics();
    await getSTPAnalytics();
    setLoading(false);
  };

  useEffect(() => {
    if (stpAnalytics && qritAnalytics) {
      const installed = stpAnalytics?.totalInstall + qritAnalytics?.totalInstall;
      setTotalInstall(installed);

      const accounts = stpAnalytics?.totalAccount + qritAnalytics?.totalAccount;
      setTotalAccounts(accounts);

      const users = stpAnalytics?.totalUser + qritAnalytics?.totalUser;
      setTotalUsers(users);

      const subscribed = stpAnalytics?.totalSubscriber + qritAnalytics?.totalSubscriber;
      setTotalSubsriber(subscribed);
    }
    
  }, [stpAnalytics, qritAnalytics]);

  useEffect(() => {
    (async()=> {
      await fetchData();
    })()
    const interval = setInterval(fetchData, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container-fluid py-2">
      <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="card  mb-2">
            <div className="card-header p-2 ps-3">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-sm mb-0 text-capitalize">Installations</p>
                  <h4 className="mb-0">{totalInstall || 0}</h4>
                </div>
                <div className="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i className="material-symbols-rounded opacity-10">
                    download
                  </i>
                </div>
              </div>
            </div>
            <hr className="dark horizontal my-0" />
            <div className="card-footer p-2 ps-3">
              {/* <p className="mb-0 text-sm"><span className="text-success font-weight-bolder">+55% </span>than last week</p> */}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="card  mb-2">
            <div className="card-header p-2 ps-3">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-sm mb-0 text-capitalize">Accounts</p>
                  <h4 className="mb-0">{totalAccounts || 0}</h4>
                </div>
                <div className="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i className="material-symbols-rounded opacity-10">
                    account_circle
                  </i>
                </div>
              </div>
            </div>
            <hr className="dark horizontal my-0" />
            <div className="card-footer p-2 ps-3">
              {/* <p className="mb-0 text-sm"><span className="text-success font-weight-bolder">+3% </span>than last month</p> */}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="card  mb-2">
            <div className="card-header p-2 ps-3">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-sm mb-0 text-capitalize">Users</p>
                  <h4 className="mb-0">{totalUsers || 0}</h4>
                </div>
                <div className="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i className="material-symbols-rounded opacity-10">person</i>
                </div>
              </div>
            </div>
            <hr className="dark horizontal my-0" />
            <div className="card-footer p-2 ps-3">
              {/* <p className="mb-0 text-sm"><span className="text-success font-weight-bolder">+35% </span>than last month</p> */}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="card  mb-2">
            <div className="card-header p-2 ps-3">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-sm mb-0 text-capitalize">Subscribers</p>
                  <h4 className="mb-0">{totalSubscriber || 0}</h4>
                </div>
                <div className="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i className="material-symbols-rounded opacity-10">
                    subscriptions
                  </i>
                </div>
              </div>
            </div>
            <hr className="dark horizontal my-0" />
            <div className="card-footer p-2 ps-3">
              {/* <p className="mb-0 text-sm">Just updated</p> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-8 mt-lg-0 mt-4">
          <div className="card">
            <div className="card-header pb-0 p-3">
              <div className="d-flex justify-content-between">
                <h6 className="mb-0">Customers per app</h6>
              </div>
            </div>
            <div className="card-body p-3">
              <ul className="list-group list-group-flush list my--3">
                <li className="list-group-item px-0 border-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="text-xs font-weight-bold mb-0">AppName:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        QR Item Tracker Pro
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">
                        Installations:
                      </p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {qritAnalytics?.totalInstall}
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">Accounts:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {qritAnalytics?.totalAccount}
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">Users:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {qritAnalytics?.totalUser}
                      </h6>
                    </div>
                  </div>
                  <hr className="horizontal dark mt-3 mb-1" />
                </li>
                <li className="list-group-item px-0 border-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="text-xs font-weight-bold mb-0">AppName:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        Shipment Tracker Pro
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">
                        Installations:
                      </p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {stpAnalytics?.totalInstall}
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">Accounts:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {stpAnalytics?.totalAccount}
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">Users:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {stpAnalytics?.totalUser}
                      </h6>
                    </div>
                  </div>
                  <hr className="horizontal dark mt-3 mb-1" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-4 mt-lg-0 mt-4">
          <div className="card">
            <div className="card-header pb-0 p-3">
              <div className="d-flex justify-content-between">
                <h6 className="mb-0">Subscribers per app</h6>
              </div>
            </div>
            <div className="card-body p-3">
              <ul className="list-group list-group-flush list my--3">
                <li className="list-group-item px-0 border-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="text-xs font-weight-bold mb-0">AppName:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        QR Item Tracker Pro
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">
                        Subscribers
                      </p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {qritAnalytics?.totalSubscriber}
                      </h6>
                    </div>
                  </div>
                  <hr className="horizontal dark mt-3 mb-1" />
                </li>
                <li className="list-group-item px-0 border-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="text-xs font-weight-bold mb-0">AppName:</p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        Shipment Tracker Pro
                      </h6>
                    </div>
                    <div className="col text-center">
                      <p className="text-xs font-weight-bold mb-0">
                        Subscribers
                      </p>
                      <h6 className="text-sm font-weight-normal mb-0">
                        {stpAnalytics?.totalSubscriber}
                      </h6>
                    </div>
                  </div>
                  <hr className="horizontal dark mt-3 mb-1" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
